<div *ngIf="isSaving" class="email-relay-spinner-block">
    <mat-progress-bar mode="indeterminate" [color]="'primary'"></mat-progress-bar>
</div>

<div mat-dialog-content>
    <h2 class="mt-0">Change Password</h2>

        <form [formGroup]="formGroup" novalidate>
        <input id="username"
               type="text"
               title=""
               [value]="injectedData.user?.email"
               style="display: none"
        >

        <div class="field-editing current-password">
            <ngc-password [userEmail]="injectedData.user.email"
                          [passwordCtrl]="currentPassword"
                          [label]="'Current Password'"
                          [isConfirmPassword]="false"
                          [isCurrentPassword]="true"
                          [isVertical]="isVertical"
                          [required]="true"
                          [hidePassword$]="hidePassword$"
            >
            </ngc-password>
        </div>

        <div class="field-editing new-password">
            <ngc-password [userEmail]="injectedData.user.email"
                          [passwordCtrl]="password"
                          [confirmPasswordCtrl]="confirmPassword"
                          [label]="'New Password'"
                          [isConfirmPassword]="false"
                          [isVertical]="isVertical"
                          [required]="true"
                          [hidePassword$]="hidePassword$"
                          [hasGenerateBtn]="true"
            >
            </ngc-password>
        </div>

        <div class="field-editing confirm-password">
            <ngc-password [userEmail]="injectedData.user.email"
                          [passwordCtrl]="confirmPassword"
                          [label]="'Confirm New Password'"
                          [isConfirmPassword]="true"
                          [isVertical]="isVertical"
                          [required]="true"
                          [hidePassword$]="hidePassword$"
                          [hasPasswordErrors]="!!password?.errors"
                          [hasGenerateBtn]="true"
            >
            </ngc-password>
        </div>
        <div class="field-editing">
            <div class="form-field-info mat-caption secondary-text">
                {{PASSWORD_STRENGTH_INFO}}
            </div>
        </div>
    </form>

    <div class="dialog-actions">
        <button mat-button
                type="button"
                (click)="onCancel()"
                class="mr-8"
                tabindex="12"
        >
            Cancel
        </button>

        <button mat-raised-button
                type="button"
                color="primary"
                [disabled]="isSaveDisabled()"
                (click)="onSave()"
                tabindex="11"
        >
            Save
        </button>
    </div>
</div>
